<template>
  <div class="contract-list">
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="form.code" size="small" placeholder="投放编号" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-input v-model="form.bloggerName" size="small" placeholder="博主名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.contractName" size="small" placeholder="合同名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.contractCode" size="small" placeholder="合同编码" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select style="width:100%;" v-model="form.paymentStatus" clearable placeholder="审批状态" @keyup.enter.native="onSearch">
          <el-option label="待审批" :value="0"></el-option>
          <el-option label="审批中" :value="1"></el-option>
          <el-option label="审批通过" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width:100%;" v-model="form.returnStatus" clearable placeholder="回款状态" @keyup.enter.native="onSearch">
          <el-option label="未回款" :value="1"></el-option>
          <el-option label="部分回款" :value="2"></el-option>
          <el-option label="全部回款" :value="3"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item>
        <el-date-picker
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width:280px;"
          v-model="publicTimeData"
          type="datetimerange"
          range-separator="~"
          start-placeholder="最早发布时间"
          end-placeholder="最晚发布时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width:280px;"
          v-model="backTimeData"
          type="datetimerange"
          range-separator="~"
          start-placeholder="最早回款时间"
          end-placeholder="最晚回款时间">
        </el-date-picker>
      </el-form-item>
        
      <el-form-item>
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">投放总数：{{ page.total }}条</div>
        <div>
          <el-badge style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="batchClick">批量提交付款</el-button>
          </el-badge>
          <el-button type="primary" size="small" @click="onExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small" >
        <el-table-column label="投放编号" min-width="120" prop="code" align="center"></el-table-column>
        <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.bloggerName" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.bloggerName }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="mediaType" align="center">
          <template slot-scope="scope">
            {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
          </template>
        </el-table-column>
        <el-table-column label="关联合同" prop="contract" align="center" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contractName">
              <p>{{ scope.row.contractName }}</p>
              <p>{{ scope.row.contractCode }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="品牌" prop="brandName" align="center"></el-table-column>
        <el-table-column label="发布日期" min-width="120" prop="publishTime" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="执行价" prop="executePrice" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.executePrice) }}
          </template>
        </el-table-column>
        <el-table-column label="投放状态" prop="status" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("delivery_status", scope.row.status, '') }}
          </template>
        </el-table-column>
        <el-table-column label="结算状态" prop="settleStatus" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("settle_status", scope.row.settleStatus, '') }}
          </template>
        </el-table-column>
        <el-table-column label="回款状态" prop="returnStatus" align="center">
				  <template slot-scope="scope">
						<span v-if="scope.row.returnStatus==1">未回款</span>
						<span v-else-if="scope.row.returnStatus==2">部分回款</span>
						<span v-else-if="scope.row.returnStatus==3">全部回款</span>
				  </template>
			  </el-table-column>
        <el-table-column label="博主收入调整前" prop="bloggerIncomeOld" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.bloggerIncomeOld) }}
          </template>
        </el-table-column>
        <el-table-column label="调整项" prop="transPrice" align="center">
          <template slot-scope="scope">
            {{ scope.row.transMethod + scope.row.transPrice }}
          </template>
        </el-table-column>
        <el-table-column label="博主收入调整后" prop="bloggerIncome" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.bloggerIncome) }}
          </template>
        </el-table-column>
        <el-table-column label="调整原因" prop="transRemark" align="center"></el-table-column>
        <el-table-column prop="status" align="center" label="审批状态">
          <template slot-scope="scope">
            <div>{{scope.row.paymentStatus == 0?"待提交":scope.row.paymentStatus == 1?"审批中":scope.row.paymentStatus == 2?"审批通过":"审批不通过"}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <!-- 进行中 -->
            <!-- 已结案,已关闭,结案审批中,关闭审批中 -->
            <div>
              <el-button type="text" size="small" @click="toShow(scope.row.id)">查看</el-button>
              <!--
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar==''" type="text" size="small" @click="openTrans(scope.row)">调整</el-button>
              -->
              <!-- todo 修改判断，查询的list中增加一个判断标记，初始化为0 则显示加入购物车，加入后修改为1 -->
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar==''" type="text" size="small" @click="addShopcar(scope.row)">加入购物车</el-button>
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar!=''" type="text" size="small" @click="subShopcar(scope.row)">删除购物车</el-button>
              
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
      <!-- 购物车 -->
      <shopCar ref="shopCar" :multiSelectList="multiSelectList" :payerInfo="payerInfo" :tableData="tableData" :contractValue="contractValue" @payInfoSave="payInfoSave" :contractDialog="contractDialog" @payInfoClose="payInfoClose"></shopCar>
    </div>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='调整项'" label-position="left" :model="transForm" ref="transForm" label-width="100px" class="demo-ruleform">
        <el-form-item  label="调整方式：" >
            <el-select v-model="transForm.transMethod" clearable placeholder="未选择">
              <el-option label="增加" :value="0"></el-option>
              <el-option label="减少" :value="1"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="调整数值：">
          <el-input v-model="transForm.transPrice"></el-input>
        </el-form-item>
        <el-form-item label="调整原因：">
          <el-input type="textarea" v-model="transForm.transRemark" rows="4" show-word-limit placeholder="请输入调整原因" maxlength="100"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="saveClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="加购物车提醒" :visible.sync="shopcarVisible" width="30%">
      <div>
        <div style="margin-bottom: 10px">加购物车条件：</div>
        <div class="invoiceList">
          <span>1，投放记录未提交付款申请</span>
          <i v-if="addShopcarCondition.isSubmit" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList">
          <span>2，投放记录未加入购物车</span>
          <i v-if="addShopcarCondition.isAddShopcar" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList">
          <span>3，投放记录所属博主与购物车内记录博主相同</span>
          <i v-if="addShopcarCondition.isSameBlogger" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>4，投放记录已填写投放链接</span>
          <i v-if="addShopcarCondition.isPublicUrl" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>5，投放记录已计算出博主金额（请检查博主及资源审批状态，博主税率，分成方式，投放时间及对应时间范围内的分成比例）</span>
          <i v-if="addShopcarCondition.isBloggerIncome" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
    </el-dialog>

    <!-- 导入投放记录 -->
  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { deliveryConfig } from "@/const/config/delivery";
import {
  listDelivery,
  exportDelivery,
  delDelivery,
  relateContract,
  putRecordImport
} from "@/api/business/delivery";
import { mapGetters } from "vuex";
import shopCar from "../../component/shopCarBlogger";
import { qiniuToken } from "@/api/index";
import * as qiniu from "qiniu-js";
import { bloggerPayConfirm,listBloggerPayInfo,submitBloggerPayInfo,exportBloggerPayInfo,getPayerInfo ,
  subShopcar ,addShopcar,getShopcarList} from "@/api/pay/api";
export default {
  components: {
    shopCar
  },
  data() {
    return {
      beforeShow:true, //导入按钮控制
      moban:"/files/投放记录导入模板.xlsx",
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      deliveryConfig: deliveryConfig,
      contractDialog:false,
      dialogVisible:false,
      changeForm:{
        path:"",
        name:"",
        desc:"",
      },
      form: {
        code: "",
        publicStartTime:"" ,
        publicEndTime:"" ,
        backStartTime:"" ,
        backEndTime:"" ,
        bloggerName: "",
        contractName:"",
        contractCode:"",
        customerName:"",
        paymentStatus:"",
        returnStatus:"",
      },
      transForm:{
        id:"",
        transRemark:"",
        transPrice:"",
        transMethod:"",
      },
      dialogTableVisible:false,
      dialogTitle:"",
      publicTimeData:[],
      backTimeData:[],

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      paymentInfo:{
        payAccount:"",
        payAccountNum:"" ,
        payType:1 ,
        transMethodBatch:"",
        transRemarkBatch:"",
        payReason:"",
        payDepart:"",
      },

      addShopcarCondition:{
        isSubmit:false ,
        isAddShopcar:false,
        isAllBack:false,
        isBloggerIncome:false,
        isSameBlogger:false,
        isPublicUrl:false
      },
      shopcarVisible:false,

      tableData: [],
      tableLoading: false,
      multiSelectList:[],
      contractId:"",
      batchType:"",
      contractValue:{
        submitLoading: false,  
      },
      fileData:"",
      promptShow:true,
      successShow:"",
      uploadData:"",
      sheetHeader:["*账号平台","*账号名称","*关联合同编号","品牌名称","产品名称","发布形式","发布日期","执行价","投放链接","外部平台","外部平台任务ID","*结算状态","结算金额","结算日期","收款方","收款日期","分成基数金额","固定返点","最终返点"],
      payerInfo:{
        payAccount:"",
        payAccountNum:"" ,
        depositBank:"" ,
      },
    };
  },
  mounted() {
    this.getShopcar() ;
  },
  methods: {
			
    //提交博主结算付款申请
    payInfoSave(item){
      console.log("this.multiSelectList",this.multiSelectList);
      this.paymentInfo.paymentListVOs = this.multiSelectList ;
      this.paymentInfo.payAccount = item.payAccount ;
      this.paymentInfo.payAccountNum = item.payAccountNum ;
      this.paymentInfo.transMethodBatch = item.transMethodBatch ;
      this.paymentInfo.transPriceBatch = item.transPriceBatch ;
      this.paymentInfo.transRemarkBatch = item.transRemarkBatch ;
      this.paymentInfo.payReason = item.payReason ;
      this.paymentInfo.payDepart = item.payDepart ;
      this.paymentInfo.depositBank = item.depositBank ;
      this.paymentInfo.bloggerIncomeAllOld = item.bloggerIncomeAllOld ;
      this.paymentInfo.bloggerIncomeAll = item.bloggerIncomeAll ;
      submitBloggerPayInfo(this.paymentInfo).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '付款提交成功!',
            type: 'success'
          });
          this.multiSelectList = [] ;
          this.contractDialog = false ;
          this.getList();
        }
        this.contractValue.submitLoading = false ;
        console.log('=======付款提交成功=====',res)
      })
      .catch((error) => {
        this.contractValue.submitLoading = false;
      });
    },
    //批量关联合同
    batchClick(){
      let bloggerId =  this.multiSelectList[0].bloggerId ;
      if(bloggerId!=null){
        getPayerInfo({ bloggerId }).then(res=>{
          this.payerInfo.payAccount = res.data.payAccount ;
          this.payerInfo.payAccountNum = res.data.payAccountNum ;
          this.payerInfo.depositBank = res.data.depositBank ;
          this.contractDialog = true;
        })
      }else{
        this.$message.error("选中的投放记录对应的资源，没有关联博主，无法提交！");
      }
      
      

    },
    payInfoClose(){
      this.contractDialog = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        code: "",
        publicStartTime:"" ,
        publicEndTime:"" ,
        backStartTime:"" ,
        backEndTime:"" ,
        bloggerName: "",
      };
      this.publicTimeData = [] ;
      this.backTimeData = [] ;
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if(this.publicTimeData){
        this.form.publicStartTime = this.publicTimeData[0]
        this.form.publicEndTime = this.publicTimeData[1]
      }else{
        this.form.publicStartTime = ""
        this.form.publicEndTime = ""
      }
      if(this.backTimeData){
        this.form.backStartTime = this.backTimeData[0]
        this.form.backEndTime = this.backTimeData[1]
      }else{
        this.form.backStartTime = ""
        this.form.backEndTime = ""
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listBloggerPayInfo(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          for(var i = 0 ; i < res.data.length; i++){ 
              var putInCode = res.data[i].code ;

              var index2 = this.multiSelectList.findIndex(item => {
                if ( item.code == putInCode) {
                    res.data[i].isShopCar = "1" ;
                    return true;
                }
              });

          }
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },



    // 获取列表
    getShopcar() {
      let queryObj = {} ;
      queryObj.payType = 1 ;
      this.tableLoading = true;
      getShopcarList(queryObj)
        .then((res) => {
          this.multiSelectList = res.data || [];
          this.getList() ;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.multiSelectList = [];
          this.tableLoading = false;
        });
    },

    /**
     * 导出
     */
    onExport() {
      let queryObj = validate.removeFilterNull(this.form);
      exportBloggerPayInfo(queryObj).then((res) => {
        const blob = new Blob([res.data]);
        let fileName = res.headers["content-disposition"].split("filename=")[1];
        fileName = decodeURI(fileName);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }

        setTimeout(() => {
          this.$message.success("导出成功，等待文件下载完毕");
        }, 500);
      });
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      let router = this.$router.resolve({
        path: "/pay/blogger/show",
        query: { id,type:'show' },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },

    addShopcar(obj){
      obj.payType = 1 ;
      if(obj.returnStatus==1||obj.returnStatus==2){
        this.$confirm(`此投放记录未全部回款，是否继续添加购物车?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          addShopcar(obj).then(res=>{
            if(res.code === 1){
              this.addShopcarCondition = res.data ;
              if(this.addShopcarCondition.isAddShopcar&&this.addShopcarCondition.isAllBack
                  &&this.addShopcarCondition.isBloggerIncome&&this.addShopcarCondition.isPublicUrl
                  &&this.addShopcarCondition.isSameBlogger&&this.addShopcarCondition.isSubmit){
                this.shopcarVisible = false ;
                this.$message({
                  message: '加入购物车成功!',
                  type: 'success'
                });
                this.multiSelectList.push(obj) ;
                console.log("tableData=",this.tableData);
                var index = this.tableData.findIndex(item => {
                  if ( item.id == obj.id) {
                      return true;
                  }
                });
                this.tableData[index].isShopCar = "1" ;
              }else{
                this.shopcarVisible = true ;

              }

              
            }
          })

          
        }).catch(() => {

        })  
      }else{
        addShopcar(obj).then(res=>{
          if(res.code === 1){
            this.addShopcarCondition = res.data ;
            if(this.addShopcarCondition.isAddShopcar&&this.addShopcarCondition.isAllBack
                &&this.addShopcarCondition.isBloggerIncome&&this.addShopcarCondition.isPublicUrl
                &&this.addShopcarCondition.isSameBlogger&&this.addShopcarCondition.isSubmit){
              this.shopcarVisible = false ;
              this.$message({
                message: '加入购物车成功!',
                type: 'success'
              });
              this.multiSelectList.push(obj) ;
              console.log("tableData=",this.tableData);
              var index = this.tableData.findIndex(item => {
                if ( item.id == obj.id) {
                    return true;
                }
              });
              this.tableData[index].isShopCar = "1" ;
            }else{
              this.shopcarVisible = true ;
            }
          }
        })
      }
       


      

    },

    subShopcar(obj){
      obj.payType = 1 ;

      subShopcar(obj).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '删除购物车成功!',
            type: 'success'
          });
          var index = this.multiSelectList.findIndex(item => {
          if ( item.id == obj.id) {
              return true;
          }
          })
          this.multiSelectList.splice(index,1);

          var index2 = this.tableData.findIndex(item => {
            if ( item.id == obj.id) {
                return true;
            }
          });
          this.tableData[index2].isShopCar = "" ;
        }
      })
      

    },

    //打开调整输入框
    openTrans(obj){
      this.dialogTitle = '调整项' ;
      this.dialogTableVisible = true ;
      console.log("======"+obj);
      this.transForm.id = obj.id;
      this.transForm.transMethod = obj.transMethod;
      this.transForm.transPrice = obj.transPrice;
      this.transForm.transRemark = obj.transRemark;
    },


    //保存确认调整项
    saveClick(){
      console.log("this.transForm",this.transForm)
      bloggerPayConfirm(this.transForm).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '确认调整项成功!',
            type: 'success'
          });
          this.dialogTableVisible = false
          this.getList();
        }
        console.log('=======确认调整项成功=====',res)
      })
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.anniuFlex{
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-flex{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-form-item {
  &.w-25 {
    display: inline-block;
    width: 24%;
    margin-right: 1%;
    height: 64px;
  }
  &.w-70 {
    display: inline-block;
    width: 70%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
</style>